import { Box, Button, Heading, Text } from '@chakra-ui/react';
import React from 'react';

import { ReactComponent as SentImage } from '@/app/_icons/sent-image.svg';

import Styles from './thank-you-message.module.scss';

export const ThankYouMessageNewCars: React.FC<{
  sentAnotherMessage: () => void;
  onDone?: () => void;
}> = ({ sentAnotherMessage, onDone }) => {
  return (
    <Box className={Styles.enquireNowFormSentMessageWrapper}>
      <Box className={Styles.enquireNowFormSentMessage}>
        <SentImage />
        <Box className={Styles.headingElement} marginBottom={4}>
          <Heading as="h3" className={Styles.titleMd}>
            Message sent
          </Heading>
        </Box>

        <Text>
          Thank you for your enquiry, we will get back to you as soon as
          possible.
        </Text>
      </Box>
      <Box>
        <Text
          className={Styles.sendAnotherMessage}
          onClick={sentAnotherMessage}
        >
          Send another message?
        </Text>
        <Button onClick={onDone} className={Styles.btn} type="submit">
          <span>Done</span>
        </Button>
      </Box>
    </Box>
  );
};
